import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipe implements PipeTransform {
  private readonly allowedOrigins: string[];

  constructor(private sanitizer: DomSanitizer) {
    this.allowedOrigins = [environment.config.ohifViewerURL]
      .filter(Boolean)
      .map(u => { try { return new URL(u).origin; } catch { return null; } })
      .filter(Boolean);
  }

  transform(url: string): SafeResourceUrl | string {
    if (!url) return '';
    try {
      const parsed = new URL(url);
      if (this.allowedOrigins.includes(parsed.origin)) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    } catch {}
    return '';
  }
}
